<div class="table-card user-distribution-card">
  <h4 class="card-title">التوزيع حسب التخصص</h4>

  <div class="distribution-list">
    @for (item of items; track item.label) {
      <div class="distribution-item">
        <div class="distribution-item-header">
          <span class="label">{{ item.label }}</span>
          <span class="value">{{ item.count }} · {{ item.percentage }}%</span>
        </div>
        <div class="progress-track">
          <div class="progress-fill" [style.width.%]="item.percentage"></div>
        </div>
      </div>
    }
  </div>
</div>
